import React from "react";

const EuStars = () => {
  const stars = Array.from({ length: 12 }, (_, i) => {
    const a = (i / 12) * Math.PI * 2 - Math.PI / 2;
    const r = 8;
    return { x: 12 + r * Math.cos(a), y: 12 + r * Math.sin(a), key: i };
  });
  return (
    <svg viewBox="0 0 24 24" className="plate-stars" aria-hidden="true">
      {stars.map((s) => (
        <text key={s.key} x={s.x} y={s.y} textAnchor="middle" dominantBaseline="central" className="plate-star">★</text>
      ))}
    </svg>
  );
};

export const LicensePlateInput = ({ value, onChange, testid, department = "75", placeholder = "AB-123-CD", className = "" }) => (
  <div className={`plate ${className}`}>
    <div className="plate-band">
      <EuStars />
      <span className="plate-band-code">F</span>
    </div>
    <input
      data-testid={testid}
      className="plate-input"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      maxLength={9}
      autoComplete="off"
      spellCheck="false"
    />
    <div className="plate-band plate-band-right">
      <span className="plate-tricolor"><i /><i /><i /></span>
      <span className="plate-band-code">{department}</span>
    </div>
  </div>
);

export default LicensePlateInput;
